// Route guard for the platform-admin panel (ADR-0024).
//
// Wraps a Route element with a UX-only gate that reads
// session.user.platformAdmin from the localStorage-backed store. Server
// authorization is enforced independently by req.requirePlatformAdmin()
// on every /admin/* endpoint in core-api and the cross-org branches in
// auth-svc — this guard exists only so the navigation never shows the
// admin section to a regular gerente.
//
// Composes with RequireAuth — mount as
//   <RequireAuth><RequirePlatformAdmin><AdminShell /></RequirePlatformAdmin></RequireAuth>
// so the absence-of-session path stays the same as every other gated
// route (Navigate to /login).

import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useSession } from "./useSession";

export function RequirePlatformAdmin({ children }: { children: ReactNode }) {
  const session = useSession();
  const location = useLocation();
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!session.user.platformAdmin) {
    // Redirect to /, NOT to a 403 page — surfacing the route's
    // existence to a non-admin is a small information leak. Returning
    // home looks identical to "this URL does not exist."
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
